export const buildNumber = '20260506.1';
export const version = 'main';
export const latestCommit = 'eba0a441487e568df4313bd365f815895fb5ee8d';
